module.exports = __webpack_public_path__ + "img/scanning_fist.bf2d7f6c.svg";